import React, { useEffect, useState } from 'react'
import MainContentWrapper from '../../Components/MainContentWrapper'
import { getAllSettlements, getRequestsIncentives } from '../../apis/BhuMeetTeams/CustomerSuccessEngineer/stores'
import Popup from '../../ReusableFunctions/Popup'
import TableView from '../../ReusableComponents/TableView/TableView'
import { useLocation, useNavigate } from 'react-router'
import { PDRL_SUCCESS_ENGI_ROUTES } from '../../routes'

export default function ViewSettlements({
    store
}) {
    const [settlements, setSettlements] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const {pathname} =useLocation();
    const navigate=useNavigate();
    const [filters, setFilters] = useState({
        pageNumber: 1,
        pageSize: 15,
    })

    const getBesSettlementsFunc = async () => {
        try {
            setIsLoading(true);
            let settlements = await getAllSettlements(store?.id, filters.pageNumber, filters.pageSize);
            setSettlements(settlements);
            setIsLoading(false)
        } catch (err) {
            setIsLoading(false)
            Popup.alert("ERROR", "Something went wrong while getiing the settlements ")
            console.log("err", err);
        }
    }

    useEffect(() => {
        getBesSettlementsFunc()
    }, [filters])
    return (
        <MainContentWrapper header={`Settlements (${settlements[0]?.settlement_count || 0})`} rightContent={<div style={{ display: "flex", justifyContent: "flex-end", paddingBottom: "20px" }}>
        </div>
        }>
            <div style={{
                margin: "20px 0",
                height: "90%"
            }}>
                <TableView
                    showSrNo
                    loadingHeight={"500px"}
                    isLoading={isLoading}
                    onStateChange={async (changedState) => {
                        const { pageNumber } = changedState;
                        setFilters({ ...filters, pageNumber });
                    }}
                    onClickRow={(invoice) => {
                        if(pathname==='/bhumeet_team/sales/details'){
                            return ;
                        }
                        navigate(`${PDRL_SUCCESS_ENGI_ROUTES.INCENTIVEINVOICE}`, {
                            state: {
                                invoice
                            }
                        })
                     }}
                    columns={[
                        { Header: "Invoice No", accessor: "invoice_number", width: "8%" },
                        { Header: "Status", accessor: "status", width: "8%" },
                        { Header: "Amount", accessor: "total_amount", width: "8%" },
                        { Header: "Time", accessor: "generated_time", isDate: true, format: "dd/mm/yyyy", width: "8%" }
                    ]}
                    count={settlements[0]?.settlement_count}
                    pageSize={filters.pageSize}
                    pageNumber={filters.pageNumber}
                    data={settlements}
                    tableContainerHeight={"100%"}
                    hidePagination={false}
                    headerStyle={{ zIndex: 0 }}
                />
            </div>
        </MainContentWrapper>
    )
}
